<template>
  <popup-layout title="회원 등록" :is-show="isShow" width="1200">
    <template v-slot:content>
      <table-layout>
        <template v-slot:title>
          업로드 목록 (총 {{ uploadData.length }}개)
        </template>
        <template v-slot:button>
          <v-btn class="button" outlined @click="clickUpload">업로드</v-btn>
        </template>
        <template v-slot:table>
          <v-data-table
            max-height="400px"
            height="40vh"
            :headers="getHeader(headers)"
            :items="uploadData"
            no-data-text="조회된 데이터가 없습니다"
            item-key="index"
            :items-per-page="-1"
            fixed-header calculate-widths
            mobile-breakpoint="md"
          >
            <template v-slot:item.memberRole="{ value }">
              <div>{{ value }}</div>
            </template>
          </v-data-table>
        </template>
      </table-layout>
      <input @input="loadData" class="d-none" :accept="SheetJSFT" type="file" ref="file" />
    </template>
    <template v-slot:button>
      <div class="buttons-layout">
        <v-btn class="button" outlined @click="isUploadUser">등록</v-btn>
        <v-btn class="button" outlined @click="close">취소</v-btn>
      </div>
    </template>
  </popup-layout>
</template>
<script>
import PopupLayout from "@/common/layout/PopupLayout.vue";
import TableLayout from "@/common/layout/TableLayout.vue";
import XLSX from "xlsx";
import TableMixin from "@/mixin/TableMixin";
import {USER_UPLOAD_TABLE} from "@/util/TableHeaders";
import {axiosInstance} from "@/util/AxiosModule";
import DateMixin from "@/mixin/DateMixin";
import {mapGetters} from "vuex";

export default {
  name: "MemberUpload",
  components: {TableLayout, PopupLayout},
  props: ["isShow", "selectOrgData"],
  mixins: [TableMixin, DateMixin],
  data() {
    return {
      headers: USER_UPLOAD_TABLE,
      SheetJSFT: ["xlsx", "xlsb", "xlsm", "xls", "xml", "csv"].map(x => "." + x).join(","),
      uploadData: []
    }
  },
  computed: {
    ...mapGetters("login", {memberId: "memberId"})
  },
  methods: {
    clickUpload() {
      this.uploadData = [];
      this.$refs.file.click();
    },
    loadData({ target: { files } }) {
      if (!files || files.length < 1) {
        alert("올바른 파일이 아닙니다.");
        return false;
      }
      else {
        this._setReader().readAsBinaryString(files[0]);
      }
    },
    _setReader() {
      const reader = new FileReader();
      reader.onload = async ({ target: { result }}) => {
        const { Sheets, SheetNames } = await XLSX.read(result, { type: "binary" });
        const sheetName = SheetNames[0];
        const sheet = Sheets[sheetName];
        sheet.A1.w = "no";
        sheet.B1.w = "orgNm";
        sheet.C1.w = "position";
        sheet.D1.w = "memberRole";
        sheet.E1.w = "memberNm";
        sheet.F1.w = "telNum";
        sheet.G1.w = "ssno";
        sheet.H1.w = "email";
        sheet.I1.w = "loanBrokerNo";
        sheet.J1.w = "bankNm";
        sheet.K1.w = "bankAccount";
        sheet.L1.w = "hireDate";
        sheet.M1.w = "jobCode";
        sheet.N1.w = "id";
        sheet.O1.w = "headMgrYn";
        sheet.P1.w = "managementMgrYn";
        sheet.Q1.w = "salesMgrYn";
        const excelDataList = XLSX.utils.sheet_to_json(sheet);
        let idx = 0;
        excelDataList.map(item => {
          delete item["no"];
          item.orgNm = item.orgNm === "-" ? "본부" : this.removeSuffixTeam(item.orgNm);
          item.loanBrokerNo = item.loanBrokerNo === 0 ? "-" : item.loanBrokerNo;
          item.memberRole = this.setMemberRole(item.memberRole);
          item.hireDate = this.setNoDotsDate(item.hireDate);
          item.createId = this.memberId;
          item.index = idx++;
        });
        this.uploadData = excelDataList;
      }
      return reader;
    },
    removeSuffixTeam(str) {
      if (typeof str === "string") {
        return str.replace(/팀$/, "");
      }
      return str;
    },
    setMemberRole(roleNm) {
      if (roleNm === "사용자") {
        return "USER";
      } else if (roleNm === "매니저") {
        return "MANAGER";
      } else if (roleNm === "관리자") {
        return "ADMIN";
      }
    },
    isUploadUser() {
      this.showConfirm({
        message: `${this.uploadData.length}건의 회원을 등록하시겠습니까?`,
        successCallback: () => {
          this.uploadUser();
        },
        failCallback: () => {
          return false;
        }
      })
    },
    async uploadUser() {
      let memberDtoList = [];
      memberDtoList = this.uploadData;
      memberDtoList.forEach(item => {
        item.orgNm = String(item.orgNm);
        item.telNum = item.telNum.replaceAll("-", "");
        item.ssno = item.ssno.replaceAll("-", "");
        item.loanBrokerNo = item.loanBrokerNo.replaceAll("-", "");
        item.jobCode = String(item.jobCode);
        item.id = item.id ? String(item.id) : "";
        item.delYn = "N";
      });
      try {
        await axiosInstance.put("/admin/member", memberDtoList)
            .then(() => {
              this.showAlert({
                message: "회원등록이 완료되었습니다",
                successCallback: () => {
                  this.$emit("close");
                  this.$emit("refresh");
                }
              })
            })
      } catch (error) {
        if (error.response) {
          const fullMessage = error;
          const trimmedMessage = fullMessage.includes('\n') ? fullMessage.substring(fullMessage.indexOf('\n') + 1) : fullMessage;
          await this.showAlert({message: `${trimmedMessage}`});
        }
      }
    },
    close() {
      this.uploadData = [];
      this.$emit("close");
    }
  }
}
</script>

<style lang="scss" scoped>
.buttons-layout {
  width: 100%;
  margin: 20px 0;
  display: flex;
  justify-content: center;
}
</style>